module.exports = {
    //index
    'INDEX': '/',
    'GET_SETTING': 'settings',
    'SETTING': '/settings',
    'GET_FAN_CAVE_UPDATE': 'fancave-updates',

    //get signed url
    'SIGNED_INVENTORY_URL': 'inventory-url',

    //dashboard
    'DASHBOARD': '/dashboard',

    //summary
    'SUMMARY': '/nfts-summary',

    //report
    'REPORTS': 'reports/',

    //auction
    "GET_AUCTION": "auction",
    "CREATE_AUCTION": "/create-auction",
    "LIST_AUCTION": "/auctions",
    "EDIT_AUCTION": "/edit-auction",
    "DETAIL_AUCTION": "/detail-auction/",

    //admin user
    "LIST_ADMIN_USER": "/admin-users",
    "CREATE_ADMIN_USER_ROLES": "/create-admin-user-roles",

    //user
    "GET_USER": "user/",
    "LIST_USER": "/users",
    "USER_LIST": "user-list",
    "DETAIL_USER": "/detail-user/",
    "UPDATE_AMOUNT_DETAIL": "/update-amount-detail/",

    //update user amount
    "UPDATE_USER_AMOUNT": "/update-amount",

    //tv-keys
    "LIST_TV_KEYS": "/tv-keys",
    "CREAT_TV_KEYS": "/create-tv-key",
    "EDIT_TV_KEYS": "/edit-tv-key",
    "TV_KEYS": "tv-keys",
    "TV_KEY": "tv-key",

    //news
    "GET_NEWS": "news",
    "CREATE_NEWS": "/create-news",
    "LIST_NEWS": "/news",
    "EDIT_NEWS": "/edit-news",

    //coupon
    "COUPON": "promo-code",
    "GET_COUPON": "coupons",
    "CREATE_COUPON": "/create-promo-code",
    "LIST_COUPON": "/promo-codes",
    "EDIT_COUPON": "/edit-promo-code",

    //redeem
    "REDEEM": "redeem",
    "GET_REDEEM": "redemption-codes",
    "CREATE_REDEEM": "/create-redeem-code",
    "LIST_REDEEM": "/redeem-codes",
    "EDIT_REDEEM": "/edit-redeem-code",
    "DETAIL_REDEEM": "/detail-redeem/",

    //faqs
    "GET_FAQS": "faqs",
    "CREATE_FAQS": "/create-faqs",
    "LIST_FAQS": "/faqs",
    "EDIT_FAQS": "/edit-faqs",

    // faq-types
    "GET_FAQ_TYPES": "faq-types",
    "LIST_FAQ_TYPES": "/faq-types",
    "CREATE_FAQ_TYPES": "/create-faq-types",
    "EDIT_FAQ_TYPES": "/edit-faq-types",

    //category
    "CATEGORY": "category",
    "GET_CATEGORY_LIST": "category-list",
    "CATEGORIES": "categories",
    "CREATE_CATEGORY": "/create-category",
    "LIST_CATEGORY": "/categories",
    "EDIT_CATEGORY": "/edit-category",
    "GET_CATEGORY": "get-category/",
    "UPDATE_CATEGORY": "update-category/",

    //rewards
    "REWARD": "reward",
    "CREATE_REWARDS": "/create-reward",
    "LIST_REWARDS": "/rewards",
    "EDIT_REWARDS": "/edit-reward",
    "UPDATE_REWARDS": "/update-reward",
    "DELETE_REWARD": "delete-reward/",
    "GET_REWARDS": "list-reward",
    "USERS_REWARDS": "/users-rewards",

    //badges
    "BADGE": "badge",
    "CREATE_BADGES": "/create-badge",
    "LIST_BADGES": "/badges",
    "EDIT_BADGES": "/edit-badge",
    "UPDATE_BADGES": "/update-badge",
    "DELETE_BADGE": "delete-badge/",
    "GET_BADGES": "list-badge",

    //inventory
    "GET_INVENTORY": "get-inventory/",
    "INVENTORY": "inventory",
    "INVENTORY_LIST": "inventory-list",
    "CREATE_INVENTORY": "/create-inventory",
    "UPDATE_INVENTORY": "update-inventory/",
    "LIST_INVENTORY": "/inventory",
    "EDIT_INVENTORY": "/edit-inventory",
    "DELETE_INVENTORY": "delete-inventory/",

    //transfers
    "GET_TRANSFER": "transfers",

    //eth-confirm
    "GET_ETH_PAYMENT": "eth-payment-confirmation",

    //lookups
    "LOOKUP": "lookup",
    "GET_LOOKUP": "lookups",
    "CREATE_LOOKUP": "/create-lookup",
    "LIST_LOOKUP": "/lookups",
    "LOOKUPS": "lookups",
    "EDIT_LOOKUP": "/edit-lookup",
    "RelationList": "/relation-list",

    //collection
    "COLLECTION": "collection",
    "CREATE_COLLECTION": "/create-collection",
    "LIST_COLLECTION": "/collections",
    "EDIT_COLLECTION": "/edit-collection",
    "DETAIL_COLLECTION": "/detail-collection/",
    "GET_COLLECTION": "list-collection/",
    "UPDATE_COLLECTION": "update-collection/",
    "USERS_COLLECTION": "/users-collection",
    "IMPORT_COLLECTION": "/import-collection",
    "DELETE_COLLECTION": "admin/delete-collection",

    //countries
    "COUNTRIES": "countries",
    "LIST_COUNTRIES": "/countries",
    "ADD_COUNTRY": "/add-country",
    "EDIT_COUNTRY": "/edit-country",
    "DETAIL_COUNTRY": "/detail-country/",
    "UPDATE_COUNTRY": "update-country/",
    "GET_COUNTRIES": "countries",
    "GET_COUNTRY": "country",

    //nfts
    "GET_NFTS": "items",
    "CREATE_NFT": "/create-nft",
    "RESERVE_NFT": "/reserve-nft",
    "RELEASE_NFT": "/release-nft",
    "NFT_STATUS": "/nfts-status",
    "LIST_NFT": "/nfts",
    "NFT": "nft",
    "EDIT_NFT": "/edit-nft",
    "IMPORT_NFT": "/import-nft",
    "IMPORT_ITEMS": "import-items",

    //gift-avatar
    "GIFT_AVATAR": "avatar-gift",

    //nft-release
    "NFT_RELEASE": "nfts-release",

    //nft-copies
    "GET_NFT_COPIES": "item-copies",
    "CREATE_NFT_COPIES": "create-item-copy",
    "REORDER_NFT_COPIES": "/reorder-nft-copies",
    "LIST_NFT_COPIES": "/nft-copies",
    "EDIT_NFT_COPIES": "/edit-nft-copies",

    //transactions
    "GET_TRANSACTIONS": "transactions",
    "TRANSACTION": "transaction",
    "LIST_TRANSACTIONS": "/transactions",
    "TRANSACTIONS_BY_ID": "/transaction",
    "MANUAL_TRANSACTION": "/manual-transaction",

    //logout
    "LOGOUT": "/logout",

    //feedback
    "LIST_FEEDBACK": "/feedback",
    "GET_LIST_FEEDBACK": "list-feedback",

    //change-password
    "CHANGE_PASSWORD": "/change-password",

    //blockchain
    "BLOCKCHAIN_ACCOUNT": "blockchain-account",

    "LIST_CART_ITEMS": "/cart-items",
    "LIST_WALLET_HISTORY": "/wallet-history",
    "USERS_NOTIFICATIONS": "/users-notifications",
    "REFERRAL_CODES": "/referral-codes",
    "CAMPAIGN_TRANSFER": "/campain_transfer",

    // create Json routes 
    "CREATE_JSON": "/create-json",
    "USERS_LISTING": "/users_listing",
    "NEWS_LISTING": "/news_listing",

    // teams
    "LIST_TEAMS": "/teams",
    "GET_TEAMS": "team-management",
    "CREATE_TEAMS": "/create-team",
    "EDIT_TEAM": "/edit-team",

    // Trading Cards
    "LIST_TRADING_CARDS": "/trading-cards",
    "GET_TRADING_CARDS": "team-management",
    "CREATE_TRADING_CARD": "/create-trading-card",
    "EDIT_TRADING_CARD": "/edit-trading-card",

    // Rewards
    "LIST_ISL_REWARDS": "/free-nft",
    'CAMPAIGN': '/campaign/',

    //Reporting
    "LIST_REPORTING": "/reporting",

    // App Vison URL 
    APP_VISION: '/app-vision',

    // CMS Pages
    "CMS_PAGES": '/cms-pages',
    "CMS_PAGE_DETAIL": "/cms-page-detail/",
    "CMS_SECTION_DETAIL": "/cms-section-detail/",
    "GET_CMS_PAGE": 'cms-page-management/',
    "GET_PAGES": "pages",
    "CREATE_PAGES": "/create-pages",
    "LIST_PAGES": "/pages",
    "EDIT_PAGES": "/edit-pages",
};